 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"vendors-mobileTeamPage":"vendors-mobileTeamPage","mobileTeamPage":"mobileTeamPage","bulkEditor":"bulkEditor","channelStoriesPage-desktopChannelStories-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannel-766c021c":"channelStoriesPage-desktopChannelStories-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannel-766c021c","channelStoriesPage-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannel-e096a507":"channelStoriesPage-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannel-e096a507","channelStoriesPage":"channelStoriesPage","mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage-mobileChannelSearchPage":"mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage-mobileChannelSearchPage","mobileChannelBranchPage":"mobileChannelBranchPage","mobileChannelLeafPage":"mobileChannelLeafPage","mobileChannelListPage":"mobileChannelListPage","mobileChannelPage":"mobileChannelPage","mobileChannelSearchPage":"mobileChannelSearchPage","desktopUploadFinalize-gifEditPanel-gifMakerFinalize":"desktopUploadFinalize-gifEditPanel-gifMakerFinalize","desktopUploadFinalize":"desktopUploadFinalize","gifMakerSlideshow":"gifMakerSlideshow","mobile404":"mobile404","mobileAboutPage":"mobileAboutPage","mobileApplyPage-mobileJoinPage-mobileLoginPage":"mobileApplyPage-mobileJoinPage-mobileLoginPage","mobileApplyPage":"mobileApplyPage","mobileLoginPage":"mobileLoginPage","mobileChangePasswordPage":"mobileChangePasswordPage","mobileExploreCategoryPage":"mobileExploreCategoryPage","mobileExploreResultsPage-mobileSearchResultsPage":"mobileExploreResultsPage-mobileSearchResultsPage","mobileExploreResultsPage":"mobileExploreResultsPage","mobileSearchResultsPage":"mobileSearchResultsPage","mobileFavoritesPage":"mobileFavoritesPage","mobileFilmFest":"mobileFilmFest","mobileGifVideoPage":"mobileGifVideoPage","mobileResetPasswordPage":"mobileResetPasswordPage","mobileTrendingPage":"mobileTrendingPage","vendors-gifEditPanel-gifMakerFinalize":"vendors-gifEditPanel-gifMakerFinalize","vendors-gifEditPanel":"vendors-gifEditPanel","gifEditPanel":"gifEditPanel","vendors-gifMakerFinalize-mobileGifMaker":"vendors-gifMakerFinalize-mobileGifMaker","gifMakerFinalize-gifMakerVideoTrim-mobileGifMaker":"gifMakerFinalize-gifMakerVideoTrim-mobileGifMaker","gifMakerFinalize":"gifMakerFinalize","vendors-gifMakerVideoTrim-mobileGifMaker":"vendors-gifMakerVideoTrim-mobileGifMaker","vendors-mobileGifMaker":"vendors-mobileGifMaker","mobileGifMaker":"mobileGifMaker","gifMakerVideoTrim":"gifMakerVideoTrim","vendors-mobileDashboard":"vendors-mobileDashboard","mobileDashboard":"mobileDashboard","vendors-mobileJoinPage":"vendors-mobileJoinPage","mobileJoinPage":"mobileJoinPage","vendors-reactGiphyTV":"vendors-reactGiphyTV","vendors-showdown":"vendors-showdown","vendors-storybookModal":"vendors-storybookModal","storybookModal":"storybookModal","gifDetailMedia":"gifDetailMedia","appsLanding":"appsLanding","artists":"artists","desktopChannelStories":"desktopChannelStories","curationStation":"curationStation","desktopStory":"desktopStory","desktopTrending":"desktopTrending","desktopTrendingVideos":"desktopTrendingVideos","filmFest":"filmFest","homebase":"homebase","homepageBeta":"homepageBeta"}[chunkId]||chunkId) + "." + {"0":"b026af8e","1":"eeaa48d2","vendors-mobileTeamPage":"09a57d0b","mobileTeamPage":"9715d193","bulkEditor":"c818a04a","channelStoriesPage-desktopChannelStories-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannel-766c021c":"688c56c4","channelStoriesPage-mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannel-e096a507":"1f58fc44","channelStoriesPage":"1e2b6c07","mobileChannelBranchPage-mobileChannelLeafPage-mobileChannelListPage-mobileChannelPage-mobileChannelSearchPage":"75c46814","mobileChannelBranchPage":"f68474bb","mobileChannelLeafPage":"099179fb","mobileChannelListPage":"069e8ac5","mobileChannelPage":"c9fcd2e9","mobileChannelSearchPage":"9c7e03c9","desktopUploadFinalize-gifEditPanel-gifMakerFinalize":"f3697227","desktopUploadFinalize":"b9f9cfd1","gifMakerSlideshow":"9c107c8e","mobile404":"fff7bdb8","mobileAboutPage":"d5ef63bb","mobileApplyPage-mobileJoinPage-mobileLoginPage":"045fed18","mobileApplyPage":"b9e9c066","mobileLoginPage":"903122d9","mobileChangePasswordPage":"55b83ec9","mobileExploreCategoryPage":"caa6e743","mobileExploreResultsPage-mobileSearchResultsPage":"908ac2bf","mobileExploreResultsPage":"0393de72","mobileSearchResultsPage":"cb8947b1","mobileFavoritesPage":"d92383ae","mobileFilmFest":"a5340d43","mobileGifVideoPage":"110cbc87","mobileResetPasswordPage":"9b432a19","mobileTrendingPage":"456d87a2","vendors-gifEditPanel-gifMakerFinalize":"6318cb94","vendors-gifEditPanel":"e52690bf","gifEditPanel":"38810003","vendors-gifMakerFinalize-mobileGifMaker":"f7a83aaa","gifMakerFinalize-gifMakerVideoTrim-mobileGifMaker":"ba92e673","gifMakerFinalize":"745395f7","vendors-gifMakerVideoTrim-mobileGifMaker":"4f58b5c1","vendors-mobileGifMaker":"1e4bf1eb","mobileGifMaker":"6a4e9e6b","gifMakerVideoTrim":"84be2a20","vendors-mobileDashboard":"b79525aa","mobileDashboard":"cacf6224","vendors-mobileJoinPage":"cd0d7349","mobileJoinPage":"6f4b0a41","vendors-reactGiphyTV":"fd6f6281","vendors-showdown":"e56b9dac","vendors-storybookModal":"402b390d","storybookModal":"f7a6ef4e","gifDetailMedia":"ca88b24c","appsLanding":"93314aa8","artists":"5040f670","desktopChannelStories":"1c3198cd","curationStation":"171489b8","desktopStory":"a2aa1e5a","desktopTrending":"f2835e95","desktopTrendingVideos":"59492dd3","filmFest":"39a9f9f6","homebase":"445f1285","homepageBeta":"cd29b430"}[chunkId] + ".bundle.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/static/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
